import { render } from "./GenderEquity.vue?vue&type=template&id=51389cf4&ts=true"
import script from "./GenderEquity.vue?vue&type=script&lang=ts"
export * from "./GenderEquity.vue?vue&type=script&lang=ts"

import "./GenderEquity.vue?vue&type=style&index=0&id=51389cf4&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__